// extracted by mini-css-extract-plugin
export default {"header":"AsignaProSubAccounts_header__DZuMn"};